const rules = [
    {
        check: function (item) {
            let fats = getItemNutrient(item.nutrients, 'Жиры')
            let calories100 = getItemNutrient(item.nutrients, 'Калорийность');

            let fatPercent = ((fats * 9) / calories100) * 100
            return fatPercent > 50
        },
        include_cat: [],
        exclude_cat: [
            'Жиры и масла',
            'Орехи и семена',
        ],
        result: 'высокое содержание жиров'
    },
    {
        check: function (item) {
            let value = getItemNutrient(item.nutrients, 'Насыщеные жирные кислоты')
            return value > 14
        },
        include_cat: [],
        exclude_cat: [
            'Жиры и масла',
            'Орехи и семена',
        ],
        result: 'высокое содержание насыщенных жирных кислот'
    },
    {
        check: function (item) {
            let value = getItemNutrient(item.nutrients, 'Насыщеные жирные кислоты')
            return value > 20
        },
        include_cat: [
            'Жиры и масла',
            'Орехи и семена',
        ],
        exclude_cat: [
        ],
        result: 'высокое содержание насыщенных жирных кислот'
    },
    {
        check: function (item) {
            let value = getItemNutrient(item.nutrients, 'Моно- и дисахариды (сахара)')
            return value > 18
        },
        include_cat: [
        ],
        exclude_cat: [
        ],
        result: 'высокое содержание простых сахаров'
    },
    {
        check: function (item) {
            let value = getItemNutrient(item.nutrients, 'Натрий, Na')
            return value > 500
        },
        include_cat: [
        ],
        exclude_cat: [
        ],
        result: 'высокое содержание натрия'
    },
    {
        check: function (item) {
            let value = 0
            item.nutrients.forEach((item) => {
                if (item.group == 'Витамины' && item.type == 'element') {
                    let val = item.rate_100_g.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/)

                    if (val) {
                        value = value + parseFloat(val[0])
                    }
                }
            })

            return value < 120
        },
        include_cat: [
            'Снеки',
            'Фаст-фуд',
            'Кондитерские изделия',
            'Хлеб и выпечка',
            'Сосиски и колбаса',
            'Полуфабрикаты'
        ],
        exclude_cat: [
        ],
        result: 'низкое содержание витаминов'
    },
    {
        check: function (item) {
            let proteins = getItemNutrient(item.nutrients, 'Белки')
            let calories100 = getItemNutrient(item.nutrients, 'Калорийность');

            let fatPercent = ((proteins * 4) / calories100) * 100
            return fatPercent < 5
        },
        include_cat: [
            'Кондитерские изделия',
            'Ресторанная еда',
            'Десерты',
            'Полуфабрикаты',
            'Соусы и заправки',
            'Вторые блюда',
            'Каши'
        ],
        exclude_cat: [
        ],
        result: 'низкое содержание белка'
    },
    {
        check: function (item) {
            let proteins = getItemNutrient(item.nutrients, 'Белки')
            let calories100 = getItemNutrient(item.nutrients, 'Калорийность');

            let fatPercent = ((proteins * 4) / calories100) * 100
            return fatPercent < 8
        },
        include_cat: [
            'Снеки',
            'Хлеб и выпечка',
            'Выпечка'
        ],
        exclude_cat: [
        ],
        result: 'низкое содержание белка'
    },
    {
        check: function (item) {
            let calories100 = getItemNutrient(item.nutrients, 'Калорийность');

            return calories100 > 360
        },
        include_cat: [
        ],
        exclude_cat: [
        ],
        result: 'высокую калорийность'
    },
    {
        check: function (item) {
            let value = getItemNutrient(item.nutrients, 'Трансжиры');
            return value > 0.1
        },
        include_cat: [
        ],
        exclude_cat: [
        ],
        result: 'содержание трансжиров'
    },
    {
        check: function (item) {
            let value = getItemNutrient(item.nutrients, 'Алкоголь (этиловый спирт)');
            return value > 0
        },
        include_cat: [
        ],
        exclude_cat: [
        ],
        result: 'содержание алкоголя'
    },
    {
        check: function (item) {
            return !item.name.includes('без лактозы')
        },
        include_cat: [
            'Молочные продукты'
        ],
        exclude_cat: [
        ],
        result: 'содержание лактозы (при индивидуальной непереносимости)'
    },
    {
        check: function (item) {
            return true
        },
        include_cat: [
            'Снеки',
            'Полуфабрикаты',
            'Сосиски и колбаса',
            'Фаст-фуд'
        ],
        exclude_cat: [
        ],
        result: 'продукт является ультра-обработанным'
    }
]

export const getCons = (item) => {
    let cons = [];

    rules.forEach((rule, i) => {
        if (rule.exclude_cat.length && rule.exclude_cat.includes(item.category_name)) {
            return;
        }

        if (rule.include_cat.length && !rule.include_cat.includes(item.category_name)) {
            return;
        }

        if (rule.check(item)) {
            cons.push(rule.result)
        }

    })

    return cons;
}

function getItemNutrient(nutrients, name) {
    let nutrient = nutrients.find(e => e.name == name && e.value != '')
    if (!nutrient) {
        return 0;
    }
    return nutrient.value.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/)[0]
}